import {createSelector} from 'reselect'
import {getAdminStoreState} from "../../store/admin-store-selectors";

export class AuditLoggingDownloadSelectors {
    static readonly state = createSelector(getAdminStoreState, state => state.auditLogging);
    static readonly loading = createSelector(AuditLoggingDownloadSelectors.state, state => state.loading);
    static readonly error = createSelector(AuditLoggingDownloadSelectors.state, state => state.error);
}

